import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../angular-material.module';
import { FormComponent } from '../../components/form/form.component';
export class CedroModule {

static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [FormComponent],
  imports: [MaterialModule],
  exports: [FormComponent],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function CedroModule_tsickle_Closure_declarations() {
/** @type {?} */
CedroModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CedroModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
